import { introduction } from './introduction';
import { variablesAndMutability } from './variablesAndMutability';
import { userInputs } from './userInputs';

export const lessonData = [
    introduction,
    variablesAndMutability,
    userInputs,
];
